import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { Modal, Col, Row, Form } from "react-bootstrap";
import IcX from "../../components/Svg/IcX";
import styles from "./style.module.css";
import Slct from "../Slct";
import DatePicker from "../DatePicker";
import getCommercial from "../../util/getCommercial";
import Loading from "../Loading";
import Checkbox from "../../components/Checkbox";
import { formatDate } from "../../util/functions";
import { Currency, Percent, IntegerNumber, InputText } from "../../components/Input";
import { toast } from "react-toastify";
import InputWSelect2 from "../InputWSelect2";
import TableResponsive from "../TableResponsive";
import { useNavigate } from "react-router-dom";
import Required from "../Required";
import Accordion2 from "../../components/Accordion";
import Button from "../../components/Button";
import WarningBox from "../WarningBox";
import useWrapper from "../../hooks/useWrapper";
import SwitchCheckbox from "../SwitchCheckBox";
import useFormat from "../../hooks/utils/useFormat";

const ModalReceipt = props => {
  const { show, onHide, traineeLoaded, isBatch, isPayment, saveTraineeAfter = async () => {}, preLoad } = props;

  const { formatReal } = useFormat();

  const { me, config } = useWrapper();
  const navigate = useNavigate();

  const [costCenters, setcostCenters] = useState();
  const [groups, setgroups] = useState();
  const [commercialRaw, setcommercialRaw] = useState();
  const [trainees, settrainees] = useState();
  const default_selects = {
    cost_center: null,
    expense_plan: null,
    expense: null,
    group: null,
    trainee: null,
  };
  const [selects, setselects] = useState(default_selects);
  const [trainee, settrainee] = useState();
  const [providers, setproviders] = useState();
  useEffect(() => {
    show &&
      (async function () {
        if (!costCenters) {
          let _cost_centers;
          if (!isPayment) {
            _cost_centers = await api.get("cost-center?type=receita", config);
          } else {
            _cost_centers = await api.get("cost-center?type=despesa", config);
          }
          setcostCenters(
            _cost_centers.data.map(__cost_center => ({
              value: __cost_center.id,
              label: __cost_center.name,
              expensePlan: __cost_center.expensePlan.map(__expense_plan => ({
                value: __expense_plan.id,
                label: __expense_plan.name,
                expenses: __expense_plan.expenses.map(__expense => ({
                  value: __expense.id,
                  label: __expense.name,
                })),
              })),
            })),
          );
        }
        if (!groups) {
          let _groups = [];
          try {
            _groups = await getCommercial();
          } catch (error) {
            error.response.status === 401 && navigate("/no-permission");
          }

          setgroups(
            _groups
              .filter(__group => __group.has_trainee_package)
              .map(__group => ({
                label: `${__group.label} [${__group.value}]`,
                value: __group.value,
              })),
          );
        }
        if (isPayment && !providers) {
          const { data: _providers } = await api.get("providers", config);
          setproviders(
            _providers.map(__provider => ({
              value: __provider.id,
              label: __provider.name,
            })),
          );
        }
      })();
  }, [show]);

  const [traineeGroups, settraineeGroups] = useState();
  useEffect(() => {
    selects?.group &&
      show &&
      (async function () {
        settrainees();
        let _commercial;
        try {
          _commercial = await getCommercial(selects.group, null, true);
        } catch (error) {
          error.response.status === 401 && navigate("/no-permission");
        }
        setcommercialRaw(_commercial);

        if (!isBatch) {
          settrainees(
            _commercial.trainees
              .filter(__trainee => __trainee.approve_by_team === 1)
              .map(__trainee => ({
                value: __trainee.id,
                label: __trainee.name,
              })),
          );
        } else {
          let _packages = [];
          _packages = _commercial.trainees
            .filter(e => e.approve_by_team === 1)
            .map(e => {
              let _package = e.packages_data.package;
              let _singles = e.packages_data.singles;
              let _cost_trainee = _package ? _package.cost_trainee : 0;
              _singles.forEach(e2 => {
                _cost_trainee += e2.cost_trainee;
              });
              let _label = _package ? _package.name : "Nada";
              let _value = _package ? `${_package.id}:` : "null:";
              _singles.forEach((e2, index) => {
                _label += ` + ${e2.name}`;
                _value += e2.id;
                !index === _singles.length - 1 && (_value += ",");
              });
              return {
                label: _label ? _label : "Nada",
                value: _value ? _value : "nothing",
                cost_trainee: _cost_trainee,
              };
            });
          _packages = _packages.filter((e, i, a) => a.findIndex(e2 => JSON.stringify(e2) === JSON.stringify(e)) === i);
          _packages = _packages.filter(__package => __package.label !== "Nada");
          settraineeGroups(_packages);
        }
      })();
  }, [selects?.group, show]);

  const packageValues = v => {
    return {
      package: parseInt(v.split(":")[0]) || null,
      singles: v
        .split(":")[1]
        .split(",")
        .filter(e => e !== "")
        .map(e => parseInt(e)),
    };
  };

  useEffect(() => {
    if (selects.trainee_group) {
      const _packages = packageValues(selects.trainee_group);

      let _trainees = commercialRaw.trainees
        .filter(e => e.approve_by_team === 1)
        .filter(e => {
          let _trainee_packages = {
            package: e.packages_data.package ? e.packages_data.package.id : null,
            singles: e.packages_data.singles.map(e => e.id),
          };
          return JSON.stringify(_trainee_packages) === JSON.stringify(_packages);
        });
      _trainees = _trainees.map(e => ({
        label: e.name,
        value: e.id,
        due_date: e.due_date,
      }));
      _trainees.length > 1 && _trainees.unshift({ value: "<SELECT_ALL>", label: "-- Marcar Todos --" });
      settrainees(_trainees);
      let _packages_sum = 0;
      if (_packages.package) {
        _packages_sum += commercialRaw.packages_data.packages.find(
          __package => __package.id === _packages.package,
        )?.cost_trainee;
      }
      if (_packages.singles.length > 0) {
        let _singles = commercialRaw.packages_data.singles.filter(__package =>
          _packages.singles.some(__single => __single === __package.id),
        );
        _packages_sum += _singles.reduce((_total, _single) => _total + _single.cost_trainee, 0);
      }
      setvalues({
        payment_type: null,
        payment_method: null,
        has_entry: false,
        first_quota_date: null,
        last_quota_commercial: commercialRaw.negotiation?.quota_last,
        cost: _packages_sum,
        payment: 0,
        discount: null,
        discount_type: "relative",
        discount_desc: null,
        tax: null,
        tax_desc: null,
        quota_value: null,
        last_quota_rule_ignore: false,
        quota_interval: null,
      });
    }
  }, [selects.trainee_group]);

  useEffect(() => {
    selects?.trainee &&
      show &&
      (async function () {
        const _trainee_raw = await api.get(`trainees/${selects.trainee}`, config);
        let _commercial_raw;
        if (!commercialRaw) {
          try {
            _commercial_raw = await getCommercial(selects.group, null, true);
          } catch (error) {
            error.response.status === 401 && navigate("/no-permission");
          }
        } else {
          _commercial_raw = commercialRaw;
        }
        let _trainee = _commercial_raw.trainees.find(e => e.id === selects.trainee);
        if (_trainee) {
          let _trainee_online_value = _trainee.packages_data.package
            ? parseFloat(_trainee.packages_data.package.cost_trainee) +
              _trainee.packages_data.singles.reduce((p, e) => p + parseFloat(e.cost_trainee) + p, 0)
            : 0;
          _trainee.paymentSlip = _trainee_raw.data.paymentSlip;
          _trainee.last_quota_commercial = _commercial_raw.negotiation?.quota_last;
          _trainee.costs = {
            cost: traineeLoaded ? traineeLoaded.newValue : _trainee_online_value,
          };
          _trainee.costs.total = _trainee.costs.cost - _trainee.costs.payments;
        }
        settrainee(_trainee);
      })();
  }, [selects?.trainee, selects?.provider_id, show]);

  const default_values = {
    cost: null,
    payment: null,
    discount: null,
    discount_type: "relative",
    tax: null,
    last_quota_rule_ignore: false,
    quota_interval: null,
    quotas: [],
  };
  const [values, setvalues] = useState(default_values);

  useEffect(() => {
    if (trainee) {
      setvalues({
        payment_type: null,
        payment_method: null,
        has_entry: false,
        first_quota_date: null,
        last_quota_commercial: trainee.last_quota_commercial,
        cost: trainee.costs.cost,
        discount: null,
        discount_type: "relative",
        discount_desc: null,
        tax: null,
        tax_desc: null,
        quota_value: null,
        last_quota_rule_ignore: false,
        quota_interval: null,
      });
    }
  }, [trainee]);

  const [debitRemaining2, setdebitRemaining2] = useState(0);

  useEffect(() => {
    let _quotas = [];
    if (values.has_entry) {
      _quotas.push({
        label: "Entrada",
        value: "",
        editable: true,
        is_entry: true,
        due_date: new Date(),
        description: "",
        is_contribution: false,
      });
    }
    if (values.quota_value) {
      for (let i = 0; i < values.quota_value; i++) {
        let _quota_date = null;
        if (values.first_quota_date) {
          if (values.quota_interval) {
            _quota_date = new Date(
              values.first_quota_date.getFullYear(),
              values.first_quota_date.getMonth(),
              values.first_quota_date.getDate() + values.quota_interval * i,
            );
          } else {
            _quota_date = new Date(
              values.first_quota_date.getFullYear(),
              values.first_quota_date.getMonth() + i,
              values.first_quota_date.getDate(),
            );
          }
        }
        _quotas.push({
          label: `${i + 1}/${values.quota_value}`,
          value: "",
          editable: false,
          due_date: values.payment_type === "parcelado" ? _quota_date : new Date(),
          description: "",
          is_contribution: false,
        });
      }
      let _last_quota_date = _quotas[_quotas.length - 1]?.due_date;
      _last_quota_date = !!_last_quota_date ? new Date(_last_quota_date) : new Date();

      const _quotas_exceds_date = _last_quota_date > new Date(values?.last_quota_commercial);
      setvalues({
        ...values,
        quotas: _quotas?.map(__quota => ({
          ...__quota,
          ...(!!_quotas_exceds_date && !values.last_quota_rule_ignore
            ? {
                due_date: null,
              }
            : {}),
        })),
      });
      if (!!_quotas_exceds_date && !values.last_quota_rule_ignore) {
        toast.error(`
          Uma ou mais parcelas ultrapassaram o dia da Última Parcela da Turma.
          Você deverá inserir as datas manualmente.
        `);
      }
    }
  }, [
    values.has_entry,
    values.quota_value,
    values.tax,
    values.discount,
    values.payment_method === "cartao",
    values.first_quota_date,
    values.quota_interval,
    debitRemaining2,
  ]);

  useEffect(() => {
    if (values.quotas) {
      const _quotient = quotient();
      let _quotas = [...values?.quotas];

      if (_quotas?.length) {
        _quotas.forEach((__quota, __quota_i) => {
          if (!__quota.editable) {
            _quotas[__quota_i].value = _quotient;
          }
        });
        setvalues({
          ...values,
          quotas: _quotas,
        });
      }
    }
  }, [JSON.stringify(values?.quotas)]);

  useEffect(() => {
    traineeLoaded &&
      setselects({
        ...selects,
        group: traineeLoaded.commercial_id,
        trainee: traineeLoaded.trainee_id,
      });
  }, [traineeLoaded]);

  useEffect(() => {
    if (values) {
      const _debit_remaining =
        values?.cost + (values?.aditional_items?.reduce((p2, e2) => p2 + e2.price * e2.amount + (e2.fee || 0), 0) || 0);
      const equal_quotas = _debit_remaining - (values?.real_discount || 0) + (values?.real_tax || 0);
      setdebitRemaining2(equal_quotas);
    }
  }, [values]);

  const [hasAditionalItems, sethasAditionalItems] = useState([]);
  const editableSum = () => {
    const total_edits =
      values?.quotas
        ?.filter(__quota => __quota.editable)
        .reduce((__total, __quota) => __total + Number(__quota.value), 0) || 0;
    return total_edits;
  };
  const notEditableRemain = () => {
    const total_edits = editableSum();
    const remain = debitRemaining2 - total_edits;
    return remain;
  };
  const quotient = () => {
    const remaining_quotas = values?.quotas?.filter(__quota => !__quota.editable)?.length || 0;
    const quotient = notEditableRemain() / remaining_quotas || 0;
    return quotient;
  };
  const submitReceipt = async () => {
    let _error = [];
    document.querySelectorAll(".input-empty").forEach(e => {
      e.classList.remove("input-empty");
    });
    if (!selects.cost_center) {
      _error.push({ el: "selects.cost_center", parent: true });
    }
    if (!selects.expense_plan) {
      _error.push({ el: "selects.expense_plan", parent: true });
    }
    if (!selects.expense) {
      _error.push({ el: "selects.expense", parent: true });
    }
    if (!isPayment && !selects.group) {
      _error.push({ el: "selects.group", parent: true });
    }
    if (!selects.trainee && !isBatch && !isPayment) {
      _error.push({ el: "selects.trainee", parent: true });
    }
    if (!selects.trainee_multi?.length > 0 && isBatch) {
      _error.push({ el: "selects.trainee_multi", parent: true });
    }
    if (!values.payment_type && !preLoad) {
      _error.push({ el: "values.payment_type", parent: true });
    }
    if (!values.payment_method && !preLoad) {
      _error.push({ el: "values.payment_method", parent: true });
    }
    if (values.quotas?.find(__quota => !__quota.value)) {
      _error.push({ el: "__quota.value[]" });
    }
    if (values.quotas?.find(__quota => !__quota.due_date)) {
      _error.push({ el: "__quota.due_date[]" });
    }
    if (selects?.payment_for === "turma" && !selects?.commercial_id) {
      _error.push({ el: "selects.commercial_id", parent: true });
    }
    if (selects?.payment_for === "empresa" && !selects?.provider_id) {
      _error.push({ el: "selects.provider_id", parent: true });
    }
    if (_error.length > 0) {
      toast.error("Preencha todos os dados obrigatórios!");
      console.log("_error", _error);
      setTimeout(() => {
        _error.forEach(er => {
          if (er.parent) {
            document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
              el.parentElement.classList.add("input-empty");
            });
          } else {
            document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
              el.classList.add("input-empty");
            });
          }
        });
      }, 20);
    } else {
      setloadingRequest(true);

      if (!isPayment) {
        traineeLoaded &&
          !traineeLoaded.reboleto &&
          !!traineeLoaded.packagesToUpdate &&
          (await api.put(`trainees/${selects.trainee}`, traineeLoaded.packagesToUpdate, config)); // Durante a edição do formando, caso os pacotes sejam modificados, é necessário que antes de atualizar o financeiro os pacotes estejam atualizados com as novas modificações.

        let _trainees = !isBatch
          ? [{ id: selects.trainee }]
          : selects.trainee_multi?.map(__trainee => ({
              id: __trainee.value,
              due_date: __trainee.due_date,
            })) || [];

        for (const _trainee of _trainees) {
          const _quotas = values.quotas.map((__quota, __quota_i) => {
            let _due_date = __quota.due_date;
            if (isBatch) {
              _due_date.setDate(traineeLoaded?.trainee_due_date || _trainee?.due_date || 15);
            }

            const _tax_disc_per_quota = (values.real_tax - values?.real_discount) / values?.quotas?.length || 0;

            return {
              cost_center_id: selects.cost_center,
              expense_plan_id: selects.expense_plan,
              expense_id: selects.expense,
              commercial_id: selects.group,
              trainee_id: _trainee.id,
              type_payment: values.payment_type,
              method_payment: values.payment_method,
              total_quotas: values.quotas.length,
              quotas: __quota_i + 1,

              value: __quota.value,

              value_discount: values.real_discount / values.quotas.length,
              discount_description: values.discount_desc,

              tax: values.real_tax / values.quotas.length,
              tax_description: values.tax_desc,

              value_raw: __quota.value - _tax_disc_per_quota,

              entry: __quota.is_entry || false,
              due_date: _due_date,
              description: __quota.description,
              status: "nao-gerado",
              aporte: __quota.is_contribution,
            };
          });
          if (!traineeLoaded?.reboleto) {
            await api.post(
              `/paymentslips/edit-negotiation/${_trainee.id}`,
              {
                payments: _quotas,
              },
              config,
            );
          } else {
            api.post(
              `/paymentslips/reboleto/${traineeLoaded?.reboleto?.id}`,
              {
                newBoletos: _quotas,
              },
              config,
            );
          }
        }

        let _aditional_items =
          values?.aditional_items?.map(__item => ({
            payer_type: "item_adicional",
            commercial_id: selects.group,
            cost_center_id: __item.cost_center,
            expense_plan_id: __item.expense_plan,
            expense_id: __item.expense,
            event_id: __item.event,
            resource_id: __item.resource,
            description: __item.description,
            quantity: __item.amount,
            value: __item.price,
            convenience_fee: __item.fee,
            name: __item.name,
            trainees: _trainees.map(__trainee => __trainee.id),
          })) || [];

        for (const __item of _aditional_items) {
          await api.post("custom-payment", __item, config);
        }

        if (!traineeLoaded) {
          for (const __item_to_remove of hasAditionalItems) {
            await api.delete(`custom-payment/${__item_to_remove.custom_payment}`, config);
          }
        }
        setloadingRequest(false);
        toast.success("Recebimento Negociado com sucesso!");
        closeNReset();
      } else {
        if (!preLoad) {
          const _quotas =
            values?.quotas?.map((__quota, __quota_i) => {
              const _tax_disc_per_quota = (values.real_tax - values?.real_discount) / values?.quotas?.length || 0;
              return {
                cost_center_id: selects?.cost_center,
                expense_plan_id: selects?.expense_plan,
                expense_id: selects?.expense,
                description: selects?.description || null,
                provider_id: selects?.provider_id,
                commercial_id: selects?.commercial_id,
                user_id: me.id,
                payment_for: selects?.payment_for,

                value_discount: values?.real_discount / values?.quotas.length,
                discount_description: values?.discount_desc,
                tax: values?.real_tax / values?.quotas.length,
                tax_description: values?.tax_desc,

                value: __quota.value,
                value_raw: __quota.value - _tax_disc_per_quota,

                entry: __quota.is_entry || false,
                retirada: __quota.is_contribution,

                due_date: __quota?.due_date || "",
                type_payment: values?.payment_type,
                method_payment: values?.payment_method,

                total_quotas: values?.quotas.length,
                quotas: __quota_i + 1,
              };
            }) || [];
          await api.post(
            "bills-to-pay",
            {
              payments: _quotas,
            },
            config,
          );
          toast.success("Pagamento Registrado com sucesso!");
        } else {
          await api.put(
            `bills-to-pay/${selects?.id}`,
            {
              payment_for: selects.payment_for,
              cost_center_id: selects.cost_center,
              expense_plan_id: selects.expense_plan,
              expense_id: selects.expense,
              description: selects.description,
              commercial_id: selects?.commercial_id,
              provider_id: selects?.provider_id,
              value: values?.cost,
              due_date: values.due_date,
            },
            config,
          );
          toast.success("Pagamento Editado com sucesso!");
        }

        setloadingRequest(false);
        closeNReset();
      }
    }
  };

  const closeNReset = async () => {
    await saveTraineeAfter();
    onHide();
    setvalues(default_values);
    setselects(default_selects);
    settrainee(null);
  };

  const [loadingRequest, setloadingRequest] = useState(false);

  useEffect(() => {
    if (commercialRaw) {
      let _trainees = [];
      if (!!selects?.trainee_multi || !!trainee) {
        _trainees = trainee
          ? [
              {
                label: trainee?.name,
                value: trainee?.id,
              },
            ]
          : selects?.trainee_multi;
      } else {
        _trainees = [];
      }
      let _conflicts = [];
      for (const __payment of commercialRaw.custom_payments) {
        let _conflict = _trainees.find(__trainee => __trainee.value === __payment.trainee_id);
        if (!!_conflict) {
          _conflicts.push({
            ..._conflict,
            custom_payment: __payment.id,
          });
        }
      }
      sethasAditionalItems(_conflicts);
    }
  }, [selects?.trainee_multi, trainee, commercialRaw]);

  // Force Abs Tax & Discounts
  useEffect(() => {
    const _real_discount =
      values?.discount_type === "relative"
        ? (traineeLoaded?.newValue || values?.cost || 0) * (values?.discount * 0.01)
        : values?.discount;
    const _real_tax = ((traineeLoaded?.newValue || values?.cost || 0) - (_real_discount || 0)) * (values?.tax * 0.01);

    setvalues({
      ...values,
      real_discount: _real_discount || 0,
      real_tax: _real_tax || 0,
    });
  }, [values?.tax, values?.discount, values?.discount_type]);

  useEffect(() => {
    if (!!preLoad) {
      setselects(preLoad?.selects);
      setvalues(preLoad?.values);
    }
  }, [preLoad]);

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header>
        <div as="label" className="d-flex w-100">
          {!isPayment ? (
            <h2 className="page-title">Gerar Recebimento {isBatch ? "em Lote" : "Individual"}</h2>
          ) : (
            <h2 className="page-title">Registrar Pagamento</h2>
          )}
        </div>
        <button
          className={styles.closeModal}
          onClick={() => {
            onHide();
          }}
        >
          <IcX />
        </button>
      </Modal.Header>
      <Modal.Body className="bgWhite">
        {!!isPayment && (
          <Row>
            <Col sm={4}>
              <Form.Group>
                <span className="lince-input_label">Pagamento referente à</span>
                <Slct
                  placeholder="..."
                  value={selects.payment_for}
                  options={[
                    { value: "empresa", label: "Empresa" },
                    { value: "turma", label: "Turma" },
                  ]}
                  onChange={ev => {
                    setselects({
                      ...selects,
                      payment_for: ev.value,
                      commercial_id: null,
                      provider_id: null,
                    });
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
        )}
        <Row className="mt-2">
          <Col>
            <Form.Group className="selectContainer">
              <span className="lince-input_label">
                Centro de Custo <Required />
              </span>
              <Slct
                options={costCenters || []}
                value={selects.cost_center}
                name="selects.cost_center"
                onChange={ev => {
                  setselects({
                    ...selects,
                    cost_center: ev.value,
                    expense_plan: null,
                    expense: null,
                  });
                }}
                placeholder="..."
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="selectContainer">
              <span className="lince-input_label">
                Plano de Conta <Required />
              </span>
              <Slct
                options={
                  selects.cost_center
                    ? costCenters?.find(__cost_center => __cost_center.value === selects.cost_center)?.expensePlan || []
                    : []
                }
                value={selects.expense_plan}
                name="selects.expense_plan"
                onChange={ev => {
                  setselects({
                    ...selects,
                    expense_plan: ev.value,
                    expense: null,
                  });
                }}
                placeholder="..."
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="selectContainer">
              <span className="lince-input_label">
                Conta <Required />
              </span>
              <Slct
                options={
                  selects.expense_plan
                    ? costCenters
                        ?.find(__cost_center => __cost_center.value === selects.cost_center)
                        ?.expensePlan?.find(__expense_plan => __expense_plan.value === selects.expense_plan)
                        ?.expenses || []
                    : []
                }
                value={selects.expense}
                name="selects.expense"
                onChange={ev => {
                  setselects({
                    ...selects,
                    expense: ev.value,
                  });
                }}
                placeholder="..."
              />
            </Form.Group>
          </Col>
        </Row>
        {!isPayment ? (
          <Row className="mt-2">
            <Col sm={6}>
              <Form.Group className="selectContainer">
                <span className="lince-input_label">
                  Turma <Required />
                </span>
                <Slct
                  options={groups || []}
                  value={selects.group}
                  name="selects.group"
                  onChange={ev => {
                    settrainee(null);
                    setselects({
                      ...selects,
                      group: ev.value,
                      trainee: null,
                    });
                  }}
                  placeholder="..."
                  isDisabled={!!traineeLoaded}
                />
              </Form.Group>
            </Col>
            {!isBatch && (
              <Col sm={6}>
                <Form.Group className="selectContainer">
                  <span className="lince-input_label">
                    Formando <Required />
                  </span>
                  {!!selects?.group && !trainees ? (
                    <Loading small="true" />
                  ) : (
                    <Slct
                      options={trainees || []}
                      value={selects.trainee || traineeLoaded?.trainee_id}
                      name="selects.trainee"
                      onChange={ev => {
                        setselects({
                          ...selects,
                          trainee: ev.value,
                        });
                      }}
                      placeholder="..."
                      isDisabled={!!traineeLoaded}
                    />
                  )}
                </Form.Group>
              </Col>
            )}
            {isBatch && (
              <>
                <Col sm={6}>
                  <Form.Group className="selectContainer">
                    <span className="lince-input_label">
                      Grupo de Formandos <Required />
                    </span>
                    <Slct
                      options={traineeGroups || []}
                      value={selects.trainee_group}
                      name="selects.trainee_group"
                      onChange={ev => {
                        setselects({
                          ...selects,
                          trainee_group: ev.value,
                          trainee_multi: [],
                        });
                      }}
                      placeholder="..."
                    />
                  </Form.Group>
                </Col>
                <Col sm={12} className="mt-2">
                  <span className="lince-input_label">
                    Formandos <Required />
                  </span>
                  <Slct
                    isMulti="true"
                    options={trainees || []}
                    placeholder="..."
                    value={selects.trainee_multi || []}
                    name="selects.trainee_multi"
                    onChange={ev => {
                      setselects({
                        ...selects,
                        trainee_multi: ev,
                      });
                    }}
                  />
                </Col>
              </>
            )}
          </Row>
        ) : (
          <Row className="mt-2">
            <Col sm={12} className="mb-2">
              <Form.Group>
                <span className="lince-input_label">Descrição</span>
                <input
                  type="text"
                  value={selects.description}
                  onChange={__ev => {
                    setselects({
                      ...selects,
                      description: __ev.target.value,
                    });
                  }}
                />
              </Form.Group>
            </Col>
            {selects?.payment_for === "turma" && (
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">
                    Turma <Required />
                  </span>
                  <Slct
                    placeholder="..."
                    value={selects?.commercial_id}
                    name="selects.commercial_id"
                    options={groups || []}
                    onChange={ev => {
                      setselects({
                        ...selects,
                        commercial_id: ev.value,
                        provider_id: null,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            )}
            {selects?.payment_for === "empresa" && (
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">
                    Fornecedor <Required />
                  </span>
                  <Slct
                    placeholder="..."
                    value={selects.provider_id}
                    name="selects.provider_id"
                    options={providers || []}
                    onChange={ev => {
                      setselects({
                        ...selects,
                        provider_id: ev.value,
                        commercial_id: null,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            )}
            {!!selects?.payment_for && (
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">
                    Valor do Pagamento <Required />
                  </span>
                  <Currency
                    value={values?.cost}
                    valueChange={__ev => {
                      setvalues({
                        ...values,
                        cost: __ev,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            )}
            {!!preLoad && (
              <Col sm={4}>
                <span className="lince-input_label">
                  Dia do Pagamento <Required />
                </span>
                <DatePicker
                  selected={values.due_date}
                  name="values.due_date"
                  dateFormat="dd/MM/yyyy"
                  placeholder="--/--/----"
                  changeDate={__ev => {
                    setvalues({
                      ...values,
                      due_date: __ev,
                    });
                  }}
                  minDate={!isPayment ? new Date() : null}
                  maxDate={
                    values.last_quota_rule_ignore || !!isPayment ? null : new Date(values?.last_quota_commercial)
                  }
                />
              </Col>
            )}
          </Row>
        )}
        {(!!trainee || !!selects?.trainee_group) && !traineeLoaded && (
          <>
            {hasAditionalItems.length > 0 && (
              <>
                <div className="divisor mt-3 mb-3"></div>
                <Row>
                  <Col>
                    <WarningBox>
                      <p>
                        Os seguintes formandos já possuem itens adicionais em seu cadastro:{" "}
                        <b>
                          {hasAditionalItems.map(
                            (__had_aditional_items, __i) => `${__i > 0 ? ", " : ""}${__had_aditional_items.label}`,
                          )}
                        </b>
                      </p>
                      <p>
                        Caso você continue, os <b>items adicionais</b> desse(s) usuários serão substituídos.
                      </p>
                    </WarningBox>
                  </Col>
                </Row>
              </>
            )}
            <div className="divisor mt-3 mb-3"></div>

            <div className="mb-2 mt-4">
              <h2 className="mini-title">Itens adicionais:</h2>
              <p className="small-label m-0">Você também pode adicionar itens adicionais ao formando.</p>
            </div>
            {values?.aditional_items?.map((_aditional_item, i) => (
              <Accordion2 defaultActiveKey={!_aditional_item.id ? `single-${i + 1}` : ""}>
                <Accordion2.Item eventKey={`single-${i + 1}`}>
                  <Accordion2.Header>
                    <div className="d-flex align-items-center">
                      <div className="titleAccordion">
                        <span>{_aditional_item?.name}</span>
                      </div>
                    </div>
                    <Accordion2.Extras>
                      <p className="m-0">
                        R${" "}
                        {(
                          (_aditional_item?.amount || 0) * (_aditional_item?.price || 0) +
                          (_aditional_item?.fee || 0)
                        ).toFixed(2)}
                      </p>
                    </Accordion2.Extras>
                  </Accordion2.Header>
                  <Accordion2.Body>
                    <Row className="mb-3">
                      <Col>
                        <label>
                          Centro de Custo <Required />
                        </label>
                        <Slct
                          options={costCenters || []}
                          value={_aditional_item?.cost_center}
                          onChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i] = {
                              ..._aditional_items[i],
                              cost_center: __e.value,
                              expense_plan: null,
                              expense: null,
                            };
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                      <Col>
                        <label>
                          Plano de Conta <Required />
                        </label>
                        <Slct
                          options={
                            costCenters?.find(__cost_center => __cost_center.value === _aditional_item?.cost_center)
                              ?.expensePlan || []
                          }
                          value={_aditional_item?.expense_plan}
                          onChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i] = {
                              ..._aditional_items[i],
                              expense: null,
                              expense_plan: __e.value,
                            };
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                      <Col>
                        <label>
                          Conta <Required />
                        </label>
                        <Slct
                          options={
                            costCenters
                              ?.find(__cost_center => __cost_center.value === _aditional_item?.cost_center)
                              ?.expensePlan?.find(
                                __expense_plan => __expense_plan.value === _aditional_item?.expense_plan,
                              )?.expenses || []
                          }
                          value={_aditional_item?.expense}
                          onChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i] = {
                              ..._aditional_items[i],
                              expense: __e.value,
                            };
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <span className="lince-input_label">
                          Nome da Cobrança <Required />
                        </span>
                        <InputText
                          value={_aditional_item.name}
                          onChange={ev => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i].name = ev.target.value;
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                        />
                      </Col>
                      <Col>
                        <label>Evento</label>
                        <Slct
                          options={
                            [{ value: null, label: "-- Todos --" }].concat(
                              commercialRaw?.packages_data?.events.map(__event => ({
                                value: __event.id,
                                label: __event.name,
                              })) || [],
                            ) || []
                          }
                          value={_aditional_item?.event}
                          onChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i] = {
                              ..._aditional_items[i],
                              event: __e.value,
                              resource: null,
                            };
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                      <Col>
                        <label>Recurso</label>
                        <Slct
                          options={
                            (commercialRaw?.packages_data?.events || [])
                              ?.find(__event => __event.id === _aditional_item?.event)
                              ?.resources.map(__resource => ({
                                value: __resource.id,
                                label: __resource.name,
                              })) || []
                          }
                          value={_aditional_item?.resource}
                          onChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i].resource = __e.value;
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <label>Descrição</label>
                        <InputText
                          value={_aditional_item?.description}
                          onChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i].description = __e.value;
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <label>
                          Quantidade <Required />
                        </label>
                        <IntegerNumber
                          value={_aditional_item?.amount}
                          valueChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i].amount = Number(__e);
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                        />
                      </Col>
                      <Col>
                        <label>
                          Valor (Por Unidade) <Required />
                        </label>
                        <Currency
                          value={_aditional_item?.price}
                          valueChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i].price = __e;
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                        />
                      </Col>
                      <Col>
                        <label>Taxa de Conveniência</label>
                        <Currency
                          value={_aditional_item?.fee}
                          valueChange={__e => {
                            let _aditional_items = [...values?.aditional_items];
                            _aditional_items[i].fee = __e;
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-right">
                        <Button
                          size="sm"
                          color="error"
                          onClick={() => {
                            let _aditional_items = !!values?.aditional_items ? [...values?.aditional_items] : [];
                            _aditional_items.splice(i, 1);
                            setvalues({
                              ...values,
                              aditional_items: _aditional_items,
                            });
                          }}
                        >
                          Remover Item
                        </Button>
                      </Col>
                    </Row>
                    {/* )} */}
                  </Accordion2.Body>
                </Accordion2.Item>
              </Accordion2>
            ))}
            <Row className="mt-3">
              <Col>
                <Button
                  size="sm"
                  color="success"
                  onClick={() => {
                    let _aditional_items = !!values?.aditional_items ? [...values?.aditional_items] : [];
                    _aditional_items.push({ name: "" });
                    setvalues({
                      ...values,
                      aditional_items: _aditional_items,
                    });
                  }}
                >
                  Adicionar Item
                </Button>
              </Col>
            </Row>
          </>
        )}
        {(!!trainee || !!selects?.trainee_group || !!selects?.provider_id || !!selects?.commercial_id) && !preLoad ? (
          <>
            <div className="divisor mt-3 mb-3"></div>
            <Row>
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">
                    Tipo de Pagamento <Required />
                  </span>
                  <Slct
                    options={[
                      { value: "avista", label: "À Vista" },
                      { value: "parcelado", label: "A Prazo / Parcelado" },
                    ]}
                    placeholder="..."
                    value={values.payment_type}
                    name="values.payment_type"
                    onChange={ev => {
                      setvalues({
                        ...values,
                        payment_type: ev.value,
                        payment_method: null,
                        has_entry: false,
                        discount: null,
                        discount_desc: null,
                        tax: null,
                        tax_desc: null,
                        quota_value: 1,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              {!!values.payment_type && (
                <>
                  <Col sm={4}>
                    <span className="lince-input_label">
                      Método de Pagamento <Required />
                    </span>
                    <Slct
                      options={[
                        { value: "boleto", label: "Boleto" },
                        { value: "pix", label: "Pix" },
                        { value: "especie", label: "Espécie" },
                        ...(values.payment_type === "parcelado" ? [{ value: "cartao", label: "Cartão" }] : []),
                      ]}
                      placeholder="..."
                      value={values.payment_method}
                      name="values.payment_method"
                      onChange={ev => {
                        setvalues({
                          ...values,
                          payment_method: ev.value,
                        });
                      }}
                    />
                  </Col>
                </>
              )}
              {values.payment_type === "parcelado" && (
                <>
                  <Col sm={4}>
                    <Form.Group>
                      <span className="lince-input_label">Entrada</span>
                      <Slct
                        options={[
                          { value: false, label: "Não" },
                          { value: true, label: "Sim" },
                        ]}
                        placeholder="..."
                        value={values.has_entry}
                        name="values.has_entry"
                        onChange={ev => {
                          setvalues({
                            ...values,
                            has_entry: ev.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={4} className="mt-2">
                    <Form.Group>
                      <span className="lince-input_label">
                        Parcelamento <Required />
                      </span>
                      <IntegerNumber
                        value={values.quota_value}
                        name="values.quota_value"
                        valueChange={ev => {
                          setvalues({
                            ...values,
                            quota_value: ev,
                          });
                        }}
                        allowNegative={false}
                        maxlength="2"
                        placeholder="0"
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={4} className="mt-2">
                    <span className="lince-input_label">
                      {!isPayment ? "Mês" : "Dia"} do Primeiro Pagamento <Required />
                    </span>
                    {new Date() <= new Date(values?.last_quota_commercial) ||
                    values.last_quota_rule_ignore ||
                    !!isPayment ? (
                      <DatePicker
                        selected={values.first_quota_date}
                        name="values.first_quota_date"
                        dateFormat={!isPayment ? "MM/yyyy" : "dd/MM/yyyy"}
                        placeholder={!isPayment ? "--/----" : "--/--/----"}
                        changeDate={__ev => {
                          let _date_start = __ev;
                          if (!isPayment) {
                            _date_start.setDate(traineeLoaded?.trainee_due_date || trainee?.due_date || 1);
                          }

                          setvalues({
                            ...values,
                            first_quota_date: _date_start,
                          });
                        }}
                        minDate={!isPayment ? new Date() : null}
                        maxDate={
                          values.last_quota_rule_ignore || !!isPayment ? null : new Date(values?.last_quota_commercial)
                        }
                      />
                    ) : (
                      <Form.Control value={""} disabled={true} className="input-empty" />
                    )}
                  </Col>
                  <Col sm={4} className="mt-2">
                    <Form.Group className="lince-input checkbox-input">
                      <span className="lince-input_label">
                        Intervalo <Required />
                      </span>
                      <Form.Control
                        type="text"
                        value={values.quota_interval === null ? "Mensal" : values.quota_interval}
                        name="values.quota_interval"
                        onChange={ev => {
                          setvalues({
                            ...values,
                            quota_interval: ev.target.value,
                          });
                        }}
                        disabled={values.quota_interval === null}
                      />
                      <Form.Check.Label className="im-checkbox">
                        <Checkbox
                          checked={values.quota_interval !== null}
                          onChange={ev => {
                            if (ev.target.checked) {
                              setvalues({
                                ...values,
                                quota_interval: 30,
                              });
                            } else {
                              setvalues({
                                ...values,
                                quota_interval: null,
                              });
                            }
                          }}
                        />
                        <span className="lince-input_label fs-12">Em Dias</span>
                      </Form.Check.Label>
                    </Form.Group>
                  </Col>
                </>
              )}
            </Row>
            {!!values.payment_type && !isPayment && (
              <Row className="mt-2">
                <Col sm={3}>
                  <Form.Group>
                    <span className="lince-input_label">Desconto (Negociação)</span>
                    <InputWSelect2
                      selected={values.discount_type}
                      name="values.discount_type"
                      setOption={__option => {
                        setvalues({
                          ...values,
                          discount_type: __option,
                          discount: null,
                          discount_desc: null,
                        });
                      }}
                      options={[
                        {
                          label: "Absoluto (R$)",
                          value: "absolute",
                          input: (
                            <Currency
                              value={values.discount}
                              name="selects.discount"
                              valueChange={ev => {
                                setvalues({
                                  ...values,
                                  discount: ev || "",
                                });
                              }}
                            />
                          ),
                        },
                        {
                          label: "Relativo (%)",
                          value: "relative",
                          input: (
                            <Percent
                              value={values.discount || ""}
                              name="values.discount"
                              isAllowed={__ev => {
                                return !(__ev.floatValue > 100);
                              }}
                              valueChange={__ev => {
                                setvalues({
                                  ...values,
                                  discount: __ev || 0,
                                  ...(!__ev && { discount_desc: null }),
                                });
                              }}
                            />
                          ),
                        },
                      ]}
                    />
                  </Form.Group>
                </Col>
                {!!values.discount && (
                  <Col sm={3}>
                    <Form.Group>
                      <span className="lince-input_label">Descrição do Desconto</span>
                      <Form.Control
                        value={values.discount_desc}
                        name="values.discount_desc"
                        onChange={ev => {
                          setvalues({
                            ...values,
                            discount_desc: ev.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                )}
                <Col sm={3}>
                  <Form.Group>
                    <span className="lince-input_label">Taxas</span>
                    <Percent
                      value={values.tax}
                      name="values.tax"
                      valueChange={__ev => {
                        setvalues({
                          ...values,
                          tax: __ev || "",
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
                {!!values.tax && (
                  <Col sm={3}>
                    <Form.Group>
                      <span className="lince-input_label">Descrição da Taxa</span>
                      <Form.Control
                        value={values.tax_desc}
                        name="values.tax_desc"
                        onChange={ev => {
                          setvalues({
                            ...values,
                            tax_desc: ev.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>
            )}
            {values?.last_quota_commercial && (
              <Row className="mt-2">
                <Col>
                  {values.payment_type === "parcelado" && (
                    <>
                      <p
                        className={`small-label m-0`}
                        style={{
                          color: new Date() > new Date(values?.last_quota_commercial) ? "var(--color-error)" : "",
                        }}
                      >
                        Boletos só podem ser emitidos com vencimento até o dia da Última Parcela. (
                        <b>{formatDate(values?.last_quota_commercial, 7)}</b>)
                      </p>
                      <Form.Group className="d-block" style={{ marginTop: ".333rem", marginBottom: ".5rem" }}>
                        <SwitchCheckbox
                          label="Ignorar Data da Última Parcela"
                          checked={values.last_quota_rule_ignore}
                          onChange={ev => {
                            setvalues({
                              ...values,
                              last_quota_rule_ignore: ev.target.checked,
                            });
                          }}
                        />
                      </Form.Group>
                    </>
                  )}
                </Col>
              </Row>
            )}
            {!!values.payment_type && (
              <Row className="mt-3">
                <Col>
                  <TableResponsive
                    table={{
                      head: [
                        { data: "" },
                        { data: "Valor" },
                        { data: <>{values?.quotas?.length > 1 && values?.payment_method !== "cartao" && "Editar"}</> },
                        { data: <>{values.payment_type === "avista" ? "Pagamento" : "Vencimento"}</> },
                        { data: "Descrição" },
                        { data: !!isPayment ? "Retirada?" : "Aporte?" },
                      ],
                      body:
                        values?.quotas?.map((__quota, __quota_i) => ({
                          data: [
                            {
                              element: <span style={{ whiteSpace: "nowrap" }}>{__quota.label}</span>,
                            },
                            {
                              element: (
                                <Currency
                                  disabled={!__quota.editable}
                                  value={__quota.value || ""}
                                  name="__quota.value[]"
                                  onBlur={__ev => {
                                    const _min_value =
                                      (values.real_tax - values?.real_discount) / values?.quotas?.length || 0;
                                    if (__quota.value < _min_value) {
                                      const _quotas = [...values.quotas];
                                      _quotas[__quota_i].editable = false;
                                      setvalues({
                                        ...values,
                                        quotas: _quotas,
                                      });
                                      toast.error(
                                        `Você não pode inserir um valor menor que o valor fracionado das taxas por parcela! (${formatReal(
                                          _min_value,
                                        )})`,
                                      );
                                      return false;
                                    }
                                  }}
                                  isAllowed={__ev => {
                                    const _quotas = [...values.quotas];
                                    const _quotas_others = [..._quotas];
                                    const _input_value = __ev.floatValue || 0;
                                    _quotas_others.splice(__quota_i, 1);
                                    const sum_others = _quotas_others
                                      .filter(__quota => __quota.editable)
                                      .reduce((__total, __quota) => Number(__quota.value) + __total, 0);

                                    if (sum_others + _input_value <= debitRemaining2) {
                                      return true;
                                    }
                                    toast.error("Você não pode inserir um valor maior do que o valor da Negociação!");
                                    return false;
                                  }}
                                  valueChange={__ev => {
                                    if (!!__quota.editable) {
                                      let _quotas = [...values.quotas];
                                      _quotas[__quota_i].value = __ev;
                                      setvalues({
                                        ...values,
                                        quotas: _quotas,
                                      });
                                    }
                                  }}
                                />
                              ),
                            },
                            {
                              element: (
                                <>
                                  {values?.payment_method === "cartao" ||
                                  __quota.is_entry ||
                                  (!__quota.editable &&
                                    values?.quotas?.filter(__quota => !__quota.editable).length <= 1) ? (
                                    <></>
                                  ) : (
                                    <Checkbox
                                      checked={__quota.editable}
                                      name="__quota.editable[]"
                                      onChange={ev => {
                                        let _quotas = [...values.quotas];
                                        _quotas[__quota_i].editable = ev.target.checked;
                                        setvalues({
                                          ...values,
                                          quotas: _quotas,
                                        });
                                      }}
                                    />
                                  )}
                                </>
                              ),
                            },
                            {
                              element: (
                                <DatePicker
                                  selected={__quota.due_date}
                                  name="__quota.due_date[]"
                                  dateFormat={isBatch ? "MM/yyyy" : "dd/MM/yyyy"}
                                  placeholder={isBatch ? "--/----" : "--/--/----"}
                                  changeDate={ev => {
                                    let _quotas = [...values.quotas];
                                    _quotas[__quota_i].due_date = ev;
                                    setvalues({
                                      ...values,
                                      quotas: _quotas,
                                    });
                                  }}
                                  minDate={!isPayment ? new Date() : null}
                                  maxDate={
                                    values.last_quota_rule_ignore || !!isPayment || values.payment_type === "avista"
                                      ? null
                                      : new Date(values?.last_quota_commercial)
                                  }
                                />
                              ),
                            },
                            {
                              element: (
                                <Form.Control
                                  type="text"
                                  value={__quota.description}
                                  name="__quota.description[]"
                                  onChange={ev => {
                                    let _quotas = [...values.quotas];
                                    _quotas[__quota_i].description = ev.target.value;
                                    setvalues({
                                      ...values,
                                      quotas: _quotas,
                                    });
                                  }}
                                />
                              ),
                            },
                            {
                              element: (
                                <Checkbox
                                  checked={__quota.is_contribution}
                                  onChange={ev => {
                                    let _quotas = [...values.quotas];
                                    _quotas[__quota_i].is_contribution = ev.target.checked;
                                    setvalues({
                                      ...values,
                                      quotas: _quotas,
                                    });
                                  }}
                                />
                              ),
                            },
                          ],
                        })) || [],
                    }}
                  />
                </Col>
              </Row>
            )}
            <Row className="mt-2">
              <Col sm={{ span: 6, offset: 6 }}>
                <div className="row-calc-bg">
                  <p>
                    <b>Negociação</b>
                  </p>
                  <p>{formatReal(traineeLoaded?.newValue || values?.cost || 0)}</p>
                </div>
                <div className="row-calc">
                  <p>
                    <b>Desconto (Negociação)</b>
                  </p>
                  <p>{formatReal(-values.real_discount || 0)}</p>
                </div>
                <div className="row-calc">
                  <p>
                    <b>Taxas</b>
                  </p>
                  <p>{formatReal(values.real_tax || 0)}</p>
                </div>
                <div className="row-calc-bg">
                  <p>
                    <b>Resultado</b>
                  </p>
                  <p>{formatReal(debitRemaining2 || 0)}</p>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <Loading />
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <Button
            onClick={() => {
              submitReceipt();
            }}
            loading={loadingRequest}
          >
            {!isPayment ? "Gerar Recebimento" : !preLoad ? "Registrar Pagamento" : "Editar Pagamento"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalReceipt;
